import { PageTemplateContent, SkeletonLoading } from 'app/common/templates-next/page-template'


export const HistoryLoading = () => {
  return (
    <PageTemplateContent>
      <SkeletonLoading rows={10} />
    </PageTemplateContent>
  )
}
